module.exports = __webpack_public_path__ + "static/media/img23.eae3e36e.jpg";